import styled from 'styled-components';
import { TextProps } from './types';

export const Text = styled.p<TextProps>`
    text-align: ${({ center }) => (center ? 'center' : 'auto')};
`;
